module.exports = __webpack_public_path__ + "static/media/bannerBg.44d0d9ac.jpg";